/**
 * Do not remove this. This ensures that the notes appear within the container and is not hidden by the Y scrollbar of the parent.
 */

export default {
  paddingRight: 400,
  marginRight: -400,
}
